import { get, set } from 'lodash/fp';

const checkArrayUniqueLabels = (arrayPath, { requiredError, duplicateError, labelKey = 'label' } = {}) =>
    (errors, values) => {
        const list = get(arrayPath, values) || [];
        const normalized = list.map((entry) => ((entry && entry[labelKey]) || '').trim().toLowerCase());

        return list.reduce((acc, entry, index) => {
            const trimmed = ((entry && entry[labelKey]) || '').trim();
            const errorPath = `${arrayPath}[${index}].${labelKey}`;

            if ('' === trimmed) {
                return requiredError ? set(errorPath, requiredError, acc) : acc;
            }

            const isDuplicate = normalized.some((other, i) => i !== index && other === normalized[index]);

            if (isDuplicate && duplicateError) {
                return set(errorPath, duplicateError, acc);
            }

            return acc;
        }, errors);
    };

export default checkArrayUniqueLabels;
